import { memo } from 'react';

import Box from '@material-ui/core/Box';
import ErrorIcon from '@material-ui/icons/Error';

import { useStyles } from './style';

const ArticlesDetails = () => {
  const classes = useStyles();

  return (
    <Box display="flex" bgcolor="#fff" padding="15px">
      <ErrorIcon className={classes.warningIcon} />
      <Box
        marginLeft="10px"
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
      >
        <p className={classes.text}>
          Vuoden 2010 asunto-osakeyhtiölaissa säädellään osakkaan ja yhtiön
          välisen kunnossapitovastuun rajoista.
        </p>
        <p className={classes.text}>
          Yhtiöjärjestyksellä voidaan määrätä kunnossapitovastuusta myös toisin.
          Jos yhtiöjärjestyksessä on asiasta määräyksiä, niitä noudatetaan.
        </p>
        <p className={classes.text}>
          Vastuunjako pätee normaalista asumisesta, kulumisesta ja
          vanhenemisesta johtuviin vikoihin. Vastuunjaossa noudatetaan sitä
          periaatetta, että osakas vastaa hankkimistaan asennuksista, elleivät
          kyseessä ole sellaiset yhtiön kunnossapitovastuulla olevat asennukset,
          jotka eivät oleellisesti poikkea yhtiön käyttämistä.
        </p>
        <a
          className={classes.btn}
          href={'https://taloyhtion-vastuunjako.webnode.fi/'} // https://www.vastuunjako.info/ktvastuunjako/
          target="_blank"
          rel="noopener noreferrer"
        >
          TARKISTA VASTUUNJAKO
        </a>
      </Box>
    </Box>
  );
};

export default memo(ArticlesDetails);
